const initialState = { 

    showSaveCartConfirmationBanner: false
}

const reducer = (state =initialState, action) => {
    switch (action.type) {
        case 'SAVE_CART_INFO_RESPONSE':
            return { ...state, saveCartConfirmationResponse: action.data };
        case 'SAVE_CART_SUCCESS_BANNER':
            return { ...state, showSaveCartConfirmationBanner: action.data };
        default:
            return state;
    }
};
export default reducer;